// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1tID5","title":"ClientCherryInfo_title__L3WbT","itemText":"ClientCherryInfo_itemText__3qNVF"};